var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SubMenuHeader',{attrs:{"title":_vm.$t('burgerMenu.about')},on:{"onGoBack":_vm.onGoBack,"showVideo":function($event){return _vm.$emit('showVideo')}}}),_c('AboutDetails')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }